/* BRAVMEN: adiciona peças sugeridas sem sair da página atual. */
(function () {
  if (window.__bmLookInitialized) return;
  window.__bmLookInitialized = true;

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-bm-look-form]')) return;
    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-bm-look-status]');
    if (!button || button.disabled) return;

    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adicionando…';
    if (status) {
      status.textContent = '';
      status.removeAttribute('data-error');
    }

    try {
      var cartUrl = (form.getAttribute('action') || '/cart/add').replace(/\/$/, '');
      if (!cartUrl.endsWith('.js')) cartUrl += '.js';
      var response = await fetch(cartUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar este item.');
      if (status) status.textContent = 'Adicionado à sacola! Você pode continuar nesta página.';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    } catch (err) {
      if (status) {
        status.setAttribute('data-error', '');
        status.textContent = err && err.message ? err.message : 'Tente novamente em instantes.';
      }
    } finally {
      button.disabled = false;
      button.textContent = originalLabel;
    }
  });
})();
